import axios, {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosError,
  AxiosResponse,
  AxiosHeaders,
} from 'axios';
import { API_BASE_URL } from './ApiConfig';
import { isTokenValid, clearCredentials } from '../services/authUtils';

export const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// REQUEST INTERCEPTOR: Handle multipart & attach token
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // 1) If the body is FormData, remove JSON header so axios sets multipart boundary
    if (config.data instanceof FormData) {
      const headers = AxiosHeaders.from(config.headers);
      headers.delete('Content-Type');
      config.headers = headers;
    }

    // 2) Skip auth endpoints for token logic
    if (config.url?.startsWith('/auth/')) {
      return config;
    }

    // 3) Attach JWT token if present and valid
    const token = localStorage.getItem('token');
    if (token) {
      if (!isTokenValid(token)) {
        clearCredentials();
        window.location.href = '/login';
        return Promise.reject(new Error('Token expired'));
      }
      const headers = AxiosHeaders.from(config.headers);
      headers.set('Authorization', `Bearer ${token}`);
      config.headers = headers;
    }

    return config;
  },
  (err: AxiosError) => Promise.reject(err)
);

// RESPONSE INTERCEPTOR: Redirect on unauthorized
apiClient.interceptors.response.use(
  (res: AxiosResponse) => res,
  (err: AxiosError) => {
    const status = err.response?.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('userName');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);
